import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FiltroEmpresaInvestidorComponent } from './filtro-empresa-investidor.component';
import { WbaButtonModule, WbaOptGroupModule, WbaOptionModule, WbaSelect2Module, WbaSelectModule, WInputModule } from '@wbatd/design-system-wba';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
    declarations: [
      FiltroEmpresaInvestidorComponent
    ],
    imports: [
        CommonModule,
        WbaButtonModule,
        WbaSelectModule,
        WbaSelect2Module,
        WInputModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        WbaOptionModule,
        MatDatepickerModule,
        MatFormFieldModule,
        WbaOptGroupModule,
        MatInputModule,
    ],
    exports: [FiltroEmpresaInvestidorComponent],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    ]
})
export class FiltroEmpresaInvestidorModule {}
